import { Clock9 } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ClockIcon = createLucideIcon(Clock9);
